import { render, staticRenderFns } from "./SimpleTimelineInfo.vue?vue&type=template&id=663e5572"
import script from "./SimpleTimelineInfo.vue?vue&type=script&lang=js"
export * from "./SimpleTimelineInfo.vue?vue&type=script&lang=js"
import style0 from "./SimpleTimelineInfo.vue?vue&type=style&index=0&id=663e5572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports